import { useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { Switch } from "@/components/ui/switch";
import { STATUS_COLOR, formatGP } from "@/lib/format";
import { PageHead } from "@/pages/admin/AdminLayout";

export function Requests() {
  const qc = useQueryClient();
  const { data = [] } = useQuery({ queryKey: ["admin-requests"], queryFn: () => api.get("/admin/requests").then((r) => r.data) });
  const set = async (r, status) => { await api.patch(`/admin/requests/${r.id}`, { status }); qc.invalidateQueries({ queryKey: ["admin-requests"] }); qc.invalidateQueries({ queryKey: ["admin-stats"] }); };
  return (
    <div data-testid="admin-requests">
      <PageHead title="Bounties" sub="// custom name requests and offers" />
      <div className="border border-[#2a2a2a] overflow-auto">
        <table className="tac-table w-full">
          <thead><tr><th>Type</th><th>Wanted</th><th>Budget</th><th>Contact</th><th>Status</th><th>When</th></tr></thead>
          <tbody>
            {data.length === 0 && <tr><td colSpan={6} className="text-center text-[#666] py-10" data-testid="requests-empty">No bounties yet</td></tr>}
            {data.map((r) => (
              <tr key={r.id} data-testid={`request-row-${r.id}`}>
                <td className="uppercase text-xs">{r.kind}</td><td className="font-bold">{r.wanted}</td><td className="text-[#ff2a55]">{r.budget ? formatGP(r.budget) : "-"}</td>
                <td>{r.contact}<br /><span className="text-xs text-[#666]">{r.email}</span></td>
                <td><select className="field !py-1 !w-32 text-xs" style={{ color: STATUS_COLOR[r.status] }} value={r.status} onChange={(e) => set(r, e.target.value)} data-testid={`request-status-${r.id}`}>{["new", "quoted", "fulfilled", "rejected"].map((s) => <option key={s}>{s}</option>)}</select></td>
                <td className="text-xs text-[#777]">{r.created_at.slice(0, 16).replace("T", " ")}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export function Users() {
  const qc = useQueryClient();
  const { data = [] } = useQuery({ queryKey: ["admin-users"], queryFn: () => api.get("/admin/users").then((r) => r.data) });
  const patch = async (u, body) => { try { await api.patch(`/admin/users/${u.id}`, body); qc.invalidateQueries({ queryKey: ["admin-users"] }); } catch (e) { toast.error(errMsg(e)); } };
  return (
    <div data-testid="admin-users">
      <PageHead title="Users" sub="// enable accounts, grant admin" />
      <div className="border border-[#2a2a2a] overflow-auto">
        <table className="tac-table w-full">
          <thead><tr><th>Enabled</th><th>Name</th><th>Email</th><th>Role</th><th>Joined</th></tr></thead>
          <tbody>
            {data.map((u) => (
              <tr key={u.id} data-testid={`user-row-${u.email}`}>
                <td><Switch checked={u.enabled} onCheckedChange={(v) => patch(u, { enabled: v })} data-testid={`user-toggle-${u.email}`} /></td>
                <td className="font-bold">{u.name}</td><td>{u.email}</td>
                <td><select className="field !py-1 !w-32 text-xs" value={u.role} onChange={(e) => patch(u, { role: e.target.value })} data-testid={`user-role-${u.email}`}><option>customer</option><option>admin</option></select></td>
                <td className="text-xs text-[#777]">{u.created_at.slice(0, 10)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
